// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ksdu","col":"styles_col__29wgw"};